import React, { Component } from "react";

import "./Info.less";

export default class Info extends Component {

  onDivRef = (e) => {
    if (e) {
      const pEle = e.parentElement;
      if (pEle.classList.contains("nano-panel")) {
        // 调整父 .nano-panel 的 垂直布局
        pEle.style.flexDirection = "column";
      }
    };
  }

  render() {
    // tableStyleClass 类名为 表格风格(边框+底色label) 默认为添加，不需要时传空即可
    const { tableStyleClass='nano-panel-table-style' } = this.props;

    return (
      <div
        className={tableStyleClass + " nano-panel-info " + (this.props.className || "")}
        ref={this.onDivRef}
      >
        <div className="nano-panel-info-box">
          {this.props.children}
        </div>
      </div>
    );
  };
}
